import React from 'react'

import AmbassadorList from './AmbassadorList'
import BePartnerSection from './BePartnerSection'
import BlogCarousel from './blog/BlogCarousel'
import BlogListing from './blog/BlogListing'
import BlogNext from './blog/BlogNext'
import BlogPostContent from './blog/BlogPostContent'
import BlogSearch from './blog/BlogSearch'
import CardSection from './CardSection'
import ColumnList from './column/ColumnList'
import CustomHTML from './CustomHTML'
import DoubleDonation from './DoubleDonation'
import EmployeeList from './employee/EmployeeList'
import EventCalendar from './event/EventCalendar'
import EventList from './event/EventList'
import FileList from './file/FileList'
import FooterCtaSection from './FooterCtaSection'
import HeroImage from './hero/HeroImage'
import HeroMain from './hero/HeroMain'
import HeroVideo from './hero/HeroVideo'
import ImageTwoColumn from './ImageTwoColumn'
import ImpactSection from './ImpactSection'
import LogoGrid from './LogoGrid'
import MentorshipSection from './MentorshipSection'
import NewsList from './news/NewsList'
import PartnerList from './partner/PartnerList'
import ProgramListStatic from './program/ProgramListStatic'
import RichtextSection from './RichtextSection'
import SignupForm from './SignUpForm'
import SignUpFormCustom from './SignUpFormCustom'
import SimpleCarousel from './SimpleCarousel'
import StudentList from './StudentList'
import TabbedCardList from './tabbed/TabbedCardList'
import TestimonialSection from './TestimonialSection'
import TextCtaSection from './TextCtaSection'
import TextMediaSection from './TextMediaSection'
import TextSection from './TextSection'
import TextTwoColumn from './TextTwoColumn'

const Block = ({ _type, _key, ...rest }) => {
	const props = {
		...rest,
		key: _key,
		blockId: `${ _type }-${ _key }`,
	}

	switch(_type) {
		case 'ambassadorList': return <AmbassadorList {...props} />
		case 'bePartnerSection': return <BePartnerSection {...props} />
		case 'blogCarousel': return <BlogCarousel {...props} />
		case 'blogListing': return <BlogListing {...props} />
		case 'blogNext': return <BlogNext {...props} />
		case 'blogPostContent': return <BlogPostContent {...props} />
		case 'blogSearch': return <BlogSearch {...props} />
		case 'cardSection': return <CardSection {...props} />
		case 'columnList': return <ColumnList {...props} />
		case 'customHtml': return <CustomHTML {...props} />
		case 'doubleDonation': return <DoubleDonation {...props} />
		case 'employeeList': return <EmployeeList {...props} />
		case 'eventCalendar': return <EventCalendar {...props} />
		case 'eventList': return <EventList {...props} />
		case 'fileList': return <FileList {...props} />
		case 'footerCtaSection': return <FooterCtaSection {...props} />
		case 'heroImage': return <HeroImage {...props} />
		case 'heroMain': return <HeroMain {...props} />
		case 'heroVideo': return <HeroVideo {...props} />
		case 'imageTwoColumn': return <ImageTwoColumn {...props} />
		case 'impactSection': return <ImpactSection {...props} />
		case 'logoGrid' : return <LogoGrid {...props} />
		case 'mentorshipSection' : return <MentorshipSection {...props} />
		case 'newsList' : return <NewsList {...props} />
		case 'partnerList' : return <PartnerList {...props} />
		case 'programListStatic' : return <ProgramListStatic {...props} />
		case 'richtextSection' : return <RichtextSection {...props} />
		case 'signupForm' : return <SignupForm {...props} />
		case 'signUpFormCustom' : return <SignUpFormCustom {...props} />
		case 'simpleCarousel' : return <SimpleCarousel {...props} />
		case 'studentList' : return <StudentList {...props} />
		case 'tabbedCardList' : return <TabbedCardList {...props} />
		case 'testimonialSection' : return <TestimonialSection {...props} />
		case 'textCtaSection': return <TextCtaSection {...props} />
		case 'textMediaSection': return <TextMediaSection {...props} />
		case 'textSection': return <TextSection {...props} />
		case 'textTwoColumn': return <TextTwoColumn {...props} />
		default: return <div data-type={_type} key={_key} />
	}
}

const Blocks = ({ blocks, ...props }) => blocks?.map(block => !!block && (
	<Block {...block} key={block._key} {...props} />
))

export default Blocks
